/* eslint-disable unicorn/no-array-reduce */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-use-before-define */
import type { MenuItem } from '@velasca/types'

const buildSingleColumn = (
  menu: MenuItem[],
  index: number,
  columns: number,
) => {
  if (columns === 1) {
    return {
      index,
      column: menu.slice(index),
    }
  }
  const avg = countEntries(menu.slice(index)) / columns

  const currentColumn = []

  // Count entries funziona solo con i children. Siccome il primo livello è uno solo, aggiungo 1
  while (true) {
    // Prendo la entry corrente
    const entry = menu[index]

    // Se ho finito il menu esco
    if (!entry) {
      break
    }

    // In caso contrario aggiungo alla colonna corrente
    currentColumn.push(entry)

    index++

    // Se il numero di entries della colonna compilata (corrente) è >= della media, passo alla colonna successiva
    if (countColumnEntries(currentColumn) >= avg) {
      break
    }
  }

  const lastEl = currentColumn[currentColumn.length - 1]

  if (!lastEl?.children && currentColumn.length > 1) {
    index--

    return {
      index,
      column: currentColumn.slice(0, -1), //togli l'ultimo elemento dalla colonna corrente
    }
  }

  // Crea la previsione dell'ultimo menu che sfora dalla media sulla colonna successiva
  const lastElementOnNextColumn = buildMenuColumns(menu, columns - 1, index - 1)

  // Crea la previsione dell'ultimo menu che sfora dalla media sulla colonna corrente
  const lastElementOnCurrentColumn = buildMenuColumns(menu, columns - 1, index)

  // L'altezza della colonna più alta con l'elemento nella colonna successiva
  const longestColumnLengthWithLastElementOnNextColumn = getMaxColumnEntries([
    currentColumn.slice(0, -1),
    ...(lastElementOnNextColumn ?? []),
  ])

  // L'altezza della colonna più alta con l'elemento nella colonna corrente
  const longestColumnLengthWithLastElementOnCurrentColumn = getMaxColumnEntries(
    [currentColumn, ...(lastElementOnCurrentColumn ?? [])],
  )

  // Se la previsione dell'ultimo elemento sulla colonna successiva genera un menu
  // con lunghezza maggiore rispetto al menu con l'ultimo elemento sulla colonna corrente,
  // metto l'elemento in eccesso sulla colonna corrent
  // Qui devo decidere cosa fare nel caso in cui una colonna sia più lunga dell'altra.
  // Decido di fare un menu "eager", ovvero che in caso di parità mangia l'elemento
  if (
    longestColumnLengthWithLastElementOnNextColumn >=
    longestColumnLengthWithLastElementOnCurrentColumn
  ) {
    return {
      index,
      column: currentColumn, // tieni l'ultimo elemento nella colonnna corrente
    }
  }
  index--

  return {
    index,
    column: currentColumn.slice(0, -1), //togli l'ultimo elemento dalla colonna corrente
  }
}

export default function buildMenuColumns(
  menu: MenuItem[],
  columns: number,
  currentIndex = 0,
) {
  if (!menu) {
    return null
  }

  return Array.from({ length: columns }).map((_, index) => {
    const { index: nextIndex, column } = buildSingleColumn(
      menu,
      currentIndex,
      columns - index,
    )

    currentIndex = nextIndex

    return column
  })
}

const countEntries = (menu?: MenuItem[]): number => {
  if (!menu) {
    return 0
  }

  if (menu) {
    return menu.reduce((acc, child) => {
      if (child.children) {
        return acc + countEntries(child.children)
      }

      return acc
    }, menu.length)
  }

  return 0
}

// Conta le entry della colonna
const countColumnEntries = (column: MenuItem[]) => {
  return column.reduce((acc, child) => {
    return acc + 1 + countEntries(child.children)
  }, 0)
}

// Restituisci il numero di voci della colonna più lunga
const getMaxColumnEntries = (columns: MenuItem[][]) => {
  return columns.reduce((acc, column) => {
    return Math.max(acc, countColumnEntries(column))
  }, 0)
}
